// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactHubModal-cls1_ef7","cls2":"ImpactHubModal-cls2_G1V ImpactHubModal-cls1_ef7"};